import UserRoleManagementModule from "@/modules/UserRoleManagement";

function UserRoleManagermentPage() {
    return (
        <UserRoleManagementModule />
    );
}

export default UserRoleManagermentPage;